(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pricing-teaser"] && !Shopify.designMode) return;
  try {
    
  // When the holiday toggle changes, re-point each pack card's link to the selected
  // booklet's PDP pack selector and swap the cover + details link. No add-to-cart here.
  (function () {
    function initSection(section) {
      if (!section || section.__qbInit) return;
      section.__qbInit = true;

      var covers = { rh: section.dataset.qbRhCover, pe: section.dataset.qbPeCover };
      var urls = { rh: section.dataset.qbRhUrl, pe: section.dataset.qbPeUrl };

      function holiday() {
        var pe = section.querySelector('.ps-switch__input--pesach');
        return pe && pe.checked ? 'pe' : 'rh';
      }

      function sync() {
        var h = holiday();
        if (urls[h]) {
          section.querySelectorAll('[data-quickbuy-link]').forEach(function (link) {
            link.setAttribute('href', urls[h] + '#pdp-pack-selector');
          });
          var detail = section.querySelector('[data-quickbuy-detail]');
          if (detail) detail.setAttribute('href', urls[h]);
        }
        if (covers[h]) {
          section.querySelectorAll('[data-quickbuy-img]').forEach(function (img) { img.src = covers[h]; });
        }
      }

      section.querySelectorAll('.ps-switch__input').forEach(function (r) {
        r.addEventListener('change', sync);
      });
      sync();
    }

    document.querySelectorAll('.pricing-teaser').forEach(initSection);
    // Theme-editor support: re-init when the section is reloaded
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.pricing-teaser');
      if (s) initSection(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
